import { trackSearch } from '../../scripts/tag-manager';
import { RestComponent } from '../mixins/rest-component';
import get from 'lodash/get';
import './NestedCategoryFilters.scss';
import template from './NestedCategoryFilters.vhtml';

export default {
	name: 'NestedCategoryFilters',
	mixins: [
		RestComponent,
	],
	template: template,
	props: {
		filters: {
			type: Array,
			default: () => [],
		}
	},
	data: () => ({
		search: '',
		targetGroups: [],
		topics: [],
		topicsList: [],
		selectedTargetgroups: '',
		selectedTopics: '',
	}),
	computed: {
		// Setup a new topicsList based on new selected targetgroups
		newTopicsList: vm => {
			return vm.filters;
		},
		topicsStr: vm => vm.topics.map(topic => topic).join(','),
	},
	watch: {
		search() {
			this.updateUrl('event_search_str', this.search);
			trackSearch(this.search, 'Events');
			this.$emit('nested-category-filters-search', this.search);
		},
		topics() {
			this.updateUrl('topics', this.topicsStr);
			this.$emit('nested-category-filters-topics', this.topicsStr);
		},
		newTopicsList() {
			// Set new topicsList if newTopicsList changes due to selected
			this.topicsList = this.newTopicsList;
		}
	},
	methods: {
		setupPlaceholder(str) {
			return `${str}...`;
		},
	},
	mounted() {
		// Get all params and setup make initial setup
		const params = this.getAllUrlParams();
		this.selectedTopics = get(params, 'topics', '');
		this.search = get(params, 'event_search_str', '');

		// Check if there is any provided filters
		if (this.filters.length > 0) {
			// Loop through generated topicsList and add current term_id if it is included in selectedTopics
			if (this.selectedTopics !== '') {
				this.$nextTick(() => {
					this.topicsList.forEach(value => {
						if (this.selectedTopics.includes(value.term_id)) this.topics.push(value.term_id);
					});
				});
			}
		}
	}
};
